/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reconcile_Toast_Assign_SuccessInputs */

const vi_reconcile_toast_assign_success = /** @type {(inputs: Reconcile_Toast_Assign_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã gán khoản CK vào đơn`)
};

/**

* @param {Reconcile_Toast_Assign_SuccessInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const reconcile_toast_assign_success = /** @type {((inputs?: Reconcile_Toast_Assign_SuccessInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reconcile_Toast_Assign_SuccessInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_reconcile_toast_assign_success(inputs)
});